import { FC } from 'react'
import styled from 'styled-components'
import { ImageAsset, TextLegacy } from '@/components/common'
import { NewCol } from '@/components/common/layouts/NewCol'
import { NewRow } from '@/components/common/layouts/NewRow'

const ListUserReviewEmpty: FC = () => {
  return (
    <StyledContainer justify="center" align="center">
      <NewCol>
        <NewRow justify="center">
          <ImageAsset name="empty_writable_review" size={80} />
        </NewRow>
        <NewRow justify="center" style={{ marginTop: 20 }}>
          <TextLegacy align="center">{`상품 리뷰가 없습니다.\n상품을 구매하고 리뷰를 작성해 보세요!`}</TextLegacy>
        </NewRow>
      </NewCol>
    </StyledContainer>
  )
}

const StyledContainer = styled(NewRow)`
  min-height: 70vh;
`

export default ListUserReviewEmpty
